import { Item } from '@components/content/Item';
import type { ISetDataItem } from '@type/index';

export const List = ({ contentData }: {contentData: ISetDataItem[][] | null}) => {
    return <div className="schedule-list-wrap">
        <ul className="schedule-list">
            {
                contentData?.map((data, i) => {
                    const { categoryName } = data[0];
                    return <li key={i} className="schedule-item">
                        <div className="schedule-item-wrap">
                            <div className="schedule-item-category">
                                <h2 className="category">{categoryName}</h2>
                            </div>
                            <div className="schedule-item-timetable">
                                <ul className="timetable-list">
                                    {
                                        data?.map(v => <Item key={v?.id} data={v} />)
                                    }
                                </ul>
                            </div>
                        </div>
                    </li>;
                })
            }
        </ul>
    </div>;
};